// styles & images
import "./Sidebar.css";
import Avatar from "./Avatar";
import HomeIcon from "../assets/home_icon.svg";
import DocIcon from "../assets/documents_icon.svg";
import AdminIcon from "../assets/admin_icon.svg";
import LogoutIcon from "../assets/logout_icon.svg";
import AccountIcon from "../assets/account_icon.svg";
import SpeseIcon from "../assets/spese_icon.svg";
import FolderIcon from "../assets/folder_icon.svg";
import CantieriIcon from "../assets/cantieri_icon.svg";
import PresenzeIcon from "../assets/presenze_icon.svg";
import GuideIcon from "../assets/dashboard_icon.svg";

// import hooks
import { useAuthContext } from "../hooks/useAuthContext";
import { useLogout } from "../hooks/useLogout";
import { useIsAdmin } from "../hooks/useIsAdmin";

// import pacchetti
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const { user } = useAuthContext();
  const { logout } = useLogout();
  const admin = useIsAdmin(user);
  const [isMobile, setIsMobile] = useState(false);

  // Funzione per verificare se il dispositivo è mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    // Controlla all'avvio
    checkIfMobile();

    // Aggiungi event listener per il resize della finestra
    window.addEventListener("resize", checkIfMobile);

    // Cleanup dell'event listener
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  // Funzione per aprire/chiudere la sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      {isMobile && isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
      <div className={`sidebar ${!isSidebarOpen ? "sidebar-closed" : ""}`}>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <div className="user">
              <Avatar src={user.photoURL} />
              {/** qui andranno avatar e user id */}
              <p>{user.displayName}</p>
            </div>
          </div>
          <nav className="links">
            <ul>
              <li>
                <NavLink
                  to="/"
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={HomeIcon} alt="Home Icon" />
                  <span className="testo">Home</span>
                </NavLink>
              </li>
              {admin && (
                <>
                  <li>
                    <NavLink
                      to="/amministrazione"
                      className="link-items"
                      onClick={isMobile ? toggleSidebar : undefined}
                    >
                      <img src={AdminIcon} alt="Amministrazione Icon" />
                      <span className="testo">Amministrazione</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/projects"
                      className="link-items"
                      onClick={isMobile ? toggleSidebar : undefined}
                    >
                      <img src={CantieriIcon} alt="Tasks Icon" />
                      <span className="testo">Projects</span>
                    </NavLink>
                  </li>
                </>
              )}
              <li>
                <NavLink
                  to="/foglioPresenza"
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={PresenzeIcon} alt="Foglio Presenza" />
                  <span className="testo">Foglio Presenza</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/spese"
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={SpeseIcon} alt="Spesa Icon" />
                  <span className="testo">Spese</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/documenti"
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={FolderIcon} alt="Folder Icon" />
                  <span className="testo">Documenti</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to={`/anagraficaDipendente/${user.uid}`}
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={DocIcon} alt="Account Icon" />
                  <span className="testo">Anagrafica</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/guida"
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={GuideIcon} alt="Guide Icon" />
                  <span className="testo">Guida</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/profile/${user.uid}`}
                  className="link-items"
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  <img src={AccountIcon} alt="Account Icon" />
                  <span className="testo">Profilo</span>
                </NavLink>
              </li>

              <li>
                <div
                  onClick={() => {
                    if (isMobile) toggleSidebar();
                    logout();
                  }}
                  className="link-items"
                >
                  <img src={LogoutIcon} alt="Logout Icon" />
                  <span className="testo">Esci</span>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
